import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";

export const BuildIdaasFeatures = () => {
  const { t } = useTranslation();
  const features = [
    {
      icon: "icon authing-icon authing-user-2-line1",
      title: t("solution.buildIdaas.features.item1.title"),
      descript: t("solution.buildIdaas.features.item1.descript"),
    },
    {
      icon: "icon authing-icon authing-hand-coin-line",
      title: t("solution.buildIdaas.features.item2.title"),
      descript: t("solution.buildIdaas.features.item2.descript"),
    },
    {
      icon: "icon authing-icon authing-line-chart-line",
      title: t("solution.buildIdaas.features.item3.title"),
      descript: t("solution.buildIdaas.features.item3.descript"),
    },
    {
      icon: "icon authing-icon authing-shield-user-line",
      title: t("solution.buildIdaas.features.item4.title"),
      descript: t("solution.buildIdaas.features.item4.descript"),
    },
    {
      icon: "icon authing-icon authing-flow-chart",
      title: t("solution.buildIdaas.features.item5.title"),
      descript: t("solution.buildIdaas.features.item5.descript"),
    },
  ];
  return (
    <div className="build-idaas-features">
      <div className="build-idaas-features-warp">
        <div className="item-card no-border">
          <Title title={t("solution.buildIdaas.features.title")} align="left" />
        </div>
        {features.map((item) => {
          return (
            <div className="item-card">
              <div className="item-icon">
                <i className={item.icon}></i>
              </div>
              <div className="item-title">{item.title}</div>
              <div className="item-descript">{item.descript}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
